import useSWR from "swr";
import api from "./api";
import { useAuth } from "./auth";

export function useMoodTracking(active = true) {
  const { user } = useAuth();
  const { data, error, mutate } = useSWR(active && user?.org_id ? ["mood-settings", user.org_id] : null,
    () => api.get("/org/engagement-settings", { __flSkipReadCache: true }).then(response => response.data));
  return { enabled: data?.mood_tracking_enabled === true, loading: !data && !error, error, refresh: mutate };
}
